$(function(){
	$('.menu_btn').on('click', function(){
		$('.gnav').addClass('open');
	});

	$('.gnav .close, .gnav a').on('click', function(){
		$('.gnav').removeClass('open');
	});

	$('a[href^="#"]').click(function () {
		let href = $(this).attr('href');
		let headerH = $('.header').innerHeight();
		let target = $(href == '#' || href == '' ? 'html' : href);
		let position = target.offset().top - headerH;
		let speed = 500;
		$('html, body').animate({
			scrollTop: position
		}, speed, 'swing');
	});

	$(window).on('scroll', function() {
        // ウィンドウサイズが600px以下の場合
        if ($(window).width() <= 600) {
            // .trial要素の位置を取得
            let windowTop = $(window).scrollTop();
            let windowBottom = $(window).height();
			let trialTop = $('.trial').offset().top;
			let trialarea = trialTop + $('.trial').outerHeight() - windowBottom;

			if (windowTop > trialarea) {
				$('.fixed_btns').addClass('show');
			} else {
			    $('.fixed_btns').removeClass('show');
			}
		} else {
			$('.fixed_btns').removeClass('show');
		}
	}).trigger('scroll');

});